export const TRANSACTION_FEE = 595;
export const COMMERCIAL_FEE_RATE = 0.12;
export const COMMERCIAL_FEE_MIN = 595;
export const WIRE_FEE = 45;
export const ADMINISTRATIVE_FEE = 199;
export const DUAL_AGENCY_RISK_FEE = 395;
export const PERSONAL_TRANSACTION_RISK_FEE = 395;
export const HIGH_VALUE_FEE_PER_INCREMENT = 395;
export const HIGH_VALUE_THRESHOLD = 1500000;
export const HIGH_VALUE_INCREMENT = 500000;
export const NET_PAY_THRESHOLD = 595;

export const FEE_STRUCTURE_ACK_VERSION = "2026-09";

export const isCommercialTransactionType = (type) =>
  type === "buy_commercial" ||
  type === "sale_commercial" ||
  type === "both_commercial" ||
  type === "referral_commercial";

export const isReferralTransactionType = (type) =>
  type === "referral" || type === "referral_commercial";

export const shouldApplyAdministrativeFee = (summary) => {
  if (!summary) return false;
  if (summary.phase === "canceled") return false;
  return true;
};

export const calculateHighValueFee = (purchasePrice) => {
  const parsedPurchasePrice = parseFloat(
    String(purchasePrice || 0).replace(/[$,]/g, "")
  );

  if (parsedPurchasePrice <= HIGH_VALUE_THRESHOLD) {
    return 0;
  }

  const difference = parsedPurchasePrice - HIGH_VALUE_THRESHOLD;
  const additionalSteps = Math.ceil(difference / HIGH_VALUE_INCREMENT);
  return HIGH_VALUE_FEE_PER_INCREMENT * additionalSteps;
};

export const calculateCommercialTransactionFee = (commission) => {
  const parsedCommission = parseFloat(commission) || 0;
  return Math.max(parsedCommission * COMMERCIAL_FEE_RATE, COMMERCIAL_FEE_MIN);
};

export const getAdministrativeFeeForSummary = (summary) =>
  shouldApplyAdministrativeFee(summary) ? String(ADMINISTRATIVE_FEE) : "0";

export const CURRENT_AGENT_AGREEMENT_VERSION = "2026-09";
export const AGENT_AGREEMENT_SIGNING_ENABLED = true;
